import { createApp } from 'vue'
import App from './App.vue'
import router from "./router"; 
import "@/router/index.js"
import "bootstrap/dist/css/bootstrap.min.css"
import "@/assets/css/style.css";
import "@/assets/css/animate.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import VueWriter from "vue-writer";
import "@/assets/js/custom.js"
import '@fancyapps/ui/dist/fancybox/fancybox.css'


import { BootstrapIconsPlugin } from 'bootstrap-icons-vue';

/*fortawesome icon*/
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas  } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas,fab);
/*fortawesome icon*/

import AOS from "aos";
import "aos/dist/aos.css";

createApp(App).use(router).use(BootstrapIconsPlugin).use(VueWriter).component("font-awesome-icon", FontAwesomeIcon).use(AOS.init()).mount('#main-wrapper');


